import { render, staticRenderFns } from "./kakao-login.vue?vue&type=template&id=5d6741ce&"
import script from "./kakao-login.vue?vue&type=script&lang=js&"
export * from "./kakao-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports